module.exports = __webpack_public_path__ + "img/side-wdjp.f4b8a18f.png";